/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/react';
import { Component, PropsWithChildren } from 'react';
import colors from '../colors';
import { Button } from '../button';

interface IProps extends PropsWithChildren {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  css?: SerializedStyles;
  className?: string;
}

export default class Link extends Component<IProps> {
  render() {
    const { children } = this.props;
    return (
      <Button type="link" size={'small'} {...this.props}>
        {children}
      </Button>
    );
  }
}
